const SubtitleLineComponent = ({ children, ref = undefined }) => (
  <li className="subtitle" ref={ref}>
    <p>
      <span className="subtitle" children={children} />
      <br />
    </p>
  </li>
);
export default SubtitleLineComponent;
